// The customer surfaces are fluid; the attorney console is not.
//
// index.html pins the viewport to 1280px, which is right for the review
// console (a dense desktop tool with fixed grid columns: on a phone it
// renders shrunk and pinch-zoomable, the conventional "desktop site"
// behaviour) and wrong for a practice owner opening their workspace from an
// email on their phone, where the same setting produces a page of 6px text.
//
// So a customer surface switches the meta tag to device width for as long as
// it is mounted and puts it back on unmount. Mobile browsers re-evaluate the
// viewport when the tag's content changes, which is what makes this work
// without a second index.html per audience.

import { useEffect } from 'react';

const FLUID = 'width=device-width, initial-scale=1, viewport-fit=cover';

export function useDeviceViewport(): void {
  useEffect(() => {
    const meta = document.querySelector<HTMLMetaElement>('meta[name="viewport"]');
    if (!meta) return;
    const previous = meta.content;
    meta.content = FLUID;
    return () => {
      meta.content = previous;
    };
  }, []);
}
